import { UI, VStack, HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Modal as NBModal, Pressable, IPressableProps } from 'native-base';
import React from 'react';

import { paidCustodyTexts } from './constants';

export interface PaidCustodyExplanationProps {
  buttonProps?: IPressableProps;
}

export const PaidCustodyExplanation: React.FC<PaidCustodyExplanationProps> = ({ buttonProps }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const onClose = () => {
    setIsOpen(false);
  };

  const onPressLink = () => {
    window.open(paidCustodyTexts.link.url, '_blank');
  };

  return (
    <>
      <Pressable onPress={() => setIsOpen(true)} {...buttonProps}>
        <HStack space={Spacing['inline.nano']}>
          <UI.Text color="brand.tertiary.principal">Entenda custódia remunerada</UI.Text>
          <UI.Icon name="Info" size="xxs" color={Color['brand.tertiary.principal']} />
        </HStack>
      </Pressable>

      <UI.Modal
        testId="modal-paid-custody-explanation"
        isOpen={isOpen}
        onClose={onClose}
        modalProps={{ useRNModal: true }}>
        <NBModal.Content maxW={'full'}>
          <VStack p={Spacing['inset.md']} space={Spacing['stack.xxxs']}>
            <HStack justifyContent="space-between" space={Spacing['stack.xxxs']}>
              <UI.Text>{paidCustodyTexts.title}</UI.Text>
              <UI.IconButton
                p={0}
                icon="CloseModal"
                onPress={onClose}
                testId="paid-custody-close-icon"
                iconColor={Color['brand.primary.principal']}
                borderColor={Color['brand.primary.principal']}
                borderWidth="1px"
              />
            </HStack>
            <VStack space={Spacing['stack.xxs']}>
              <UI.Text>{paidCustodyTexts.explanation}</UI.Text>
              <VStack>
                <UI.Text variant="semibold">{paidCustodyTexts.observation}</UI.Text>
                {paidCustodyTexts.observations.map((observation, index) => (
                  <UI.Text key={index}>{observation}</UI.Text>
                ))}
              </VStack>
            </VStack>
            <Pressable onPress={onPressLink}>
              <UI.Text color="brand.secondary.dark" textDecorationLine="underline">
                {paidCustodyTexts.link.text}
              </UI.Text>
            </Pressable>
          </VStack>
        </NBModal.Content>
      </UI.Modal>
    </>
  );
};
